import React, { useCallback } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CardActions,
  TablePagination,
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'

const WorkoutCategory = (props) => {
  const { data, page, onPageChange, history } = props

  const goToDetail = useCallback(id => {
    history.push(`/course-weeks/${id}`)
  }, [history])

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Course Name</TableCell>
                  <TableCell>Week</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {((data && data.rows) || []).map(record => (
                    <TableRow hover className='table-row' key={record.id} onClick={() => { goToDetail(record.id) }}>
                      <TableCell>{record.id}</TableCell>
                      <TableCell>{record.course && record.course.name}</TableCell>
                      <TableCell>{record.week}</TableCell>
                      <TableCell>{record.title}</TableCell>
                      <TableCell>{record.active ? 'TRUE' : 'FALSE'}</TableCell>
                      <TableCell>
                        <EditBtn path={`/course-weeks/${record.id}/edit`} {...props} />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'flex-right'}>
        <TablePagination
          component="div"
          count={data.count || 0}
          onChangePage={onPageChange}
          page={page - 1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

export default WorkoutCategory
